import * as React from "react";

import { Loader } from "@editor/components/common/Loader";
import { useCurrentProjectContext } from "@editor/contexts/CurrentProjectContext";

import {
  LoadedSettings,
  SettingsLayout,
} from "@/editor/components/shops-ui/settings/SettingsCard";
import { routes } from "@/editor/utils/router";
import Button from "@replo/design-system/components/button/Button";
import { ArrowLeft } from "lucide-react";
import { generatePath } from "react-router-dom";

import { AddDomainForm } from "./domains/AddDomainForm";

const AddDomainPageWrapper = () => {
  const { project, isLoading: isLoadingProject } = useCurrentProjectContext();

  if (!project || project.hostingType !== "replo") {
    return null;
  }

  const handleBackToGeneral = () => {
    const generalPath = generatePath(routes.shops.settings.shops.general, {
      projectId: project.id,
    });
    // Use window.location to ensure we get the correct headers
    window.location.href = generalPath;
  };

  const handleDomainAdded = () => {
    // Navigate back to general settings after successful domain addition
    handleBackToGeneral();
  };

  const sections = [
    {
      title: "Add Domain",
      description: "Connect a custom domain to your shop",
      actions: (
        <Button
          variant="secondary"
          size="base"
          startEnhancer={<ArrowLeft size={12} />}
          onClick={handleBackToGeneral}
        >
          Back to General Settings
        </Button>
      ),
      component: (
        <AddDomainForm project={project} onDomainAdded={handleDomainAdded} />
      ),
    },
  ];

  return (
    <SettingsLayout>
      {isLoadingProject ? <Loader /> : <LoadedSettings sections={sections} />}
    </SettingsLayout>
  );
};

export default AddDomainPageWrapper;
